export default __webpack_public_path__ + "static/media/Rolling-1s-200px.a93f8788.svg";